import DealCard from '../pipeline/DealCard';

export default function AttentionList({ deals, slaMap, currentUserId, userRoles, userRole }) {
  // Support both old userRole (string) and new userRoles (array)
  const roles = userRoles || (userRole ? [userRole] : []);

  const actionItems = deals
    .filter(d => ['active', 'information_pending'].includes(d.status))
    .filter(d => {
      if (d.assigned_analyst_id === currentUserId && d.current_stage === 'analyst_review') return true;
      if (d.peer_reviewer_id === currentUserId && d.current_stage === 'peer_review') return true;
      if (roles.includes('head_of_pipeline') && d.current_stage === 'hop_review') return true;
      if (['head_of_pipeline', 'cio', 'md'].some(r => roles.includes(r)) && d.current_stage === 'iic_approval') return true;
      return false;
    })
    .slice(0, 5);

  if (!actionItems.length) {
    return (
      <div style={{ padding: '20px 0', textAlign: 'center', color: 'var(--color-text-secondary)', fontSize: 14 }}>
        No actions required right now.
      </div>
    );
  }

  function getActionLabel(deal) {
    if (deal.assigned_analyst_id === currentUserId && deal.current_stage === 'analyst_review') return 'Review';
    if (deal.peer_reviewer_id === currentUserId && deal.current_stage === 'peer_review') return 'Peer Review';
    if (roles.includes('head_of_pipeline') && deal.current_stage === 'hop_review') return 'HoP Review';
    if (deal.current_stage === 'iic_approval') return 'IIC Approval';
    return null;
  }

  return (
    <div>
      {actionItems.map(deal => (
        <DealCard
          key={deal.id}
          deal={deal}
          slaInfo={slaMap?.[deal.id]}
          actionLabel={getActionLabel(deal)}
        />
      ))}
    </div>
  );
}
